(function ($) {

RVwys.plugin['fontSize'] = true;

 $(document).bind('editorReady',function(){

	 $('.stdbutton').click(function(){
		 var oNotactiveTag = {};
		 oNotactiveTag['h6'] = true;
		 oNotactiveTag['h5'] = true;
		 oNotactiveTag['h4'] = true;
		 oNotactiveTag['h3'] = true;
		 oNotactiveTag['h2'] = true;
		 oNotactiveTag['h1'] = true;
		 if(RVwys.currentEditor) {
			 if (document.all && !range.text) {			 
				 $(RVwys.currentiFrame).focus();
			 }
			 RVwys.switchButtonStarte($(this));
		 }
	 });
 });
 
})(jQuery);